import { Injectable } from '@angular/core';
import { OrderedMap } from 'immutable';

import { ISemanticRuleResponse } from '../requesters/semantic-rule/semantic-rule.model';
import { SemanticRuleItemEntity } from './components/semantic-rule-list/semantic-rule-item.entity';
import { SemanticRuleListEntity } from './components/semantic-rule-list/semantic-rule-list.entity';

@Injectable()
export class SemanticRuleAdapter {
	public generateSemanticRuleList(
		response: ReadonlyArray<ISemanticRuleResponse>
	): SemanticRuleListEntity {
		const list = SemanticRuleListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@semantic-rule.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@semantic-rule.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 1,
			},
		]);
		const tuples = response.reduce((acc, curr) => {
			const entity = this.generateSemanticRuleItemEntity(curr);
			acc.push([`${curr.id}`, entity]);
			return acc;
		}, new Array<[string, SemanticRuleItemEntity]>());
		return list.setElements(OrderedMap(tuples));
	}

	private generateSemanticRuleItemEntity(
		response: ISemanticRuleResponse
	): SemanticRuleItemEntity {
		return SemanticRuleItemEntity.build({
			id: response.id,
			label: response?.label ?? '',
			description: response?.description ?? '',
		});
	}
}
